import axios from "axios";
import store from "../stateManagement/store";
import { AuthContextType} from "../types/types";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";
import { downloadReportRequestBody } from "../features/reports/types/types";

import jsonData from "../filters.json";
import { genericFilterType } from "../stateManagement/reducers/genericFilterReducer";
import { bannerTemplates } from "../features/createBanner/bannerTemplates";
import { BannerTemplate } from "../types";
import { getLocationParam } from "./bannerServices";
import { filterObj, filterType } from "../features/support/SupportTypes";
import { getAccessToken, getLob } from "./authenticationService";
import { openPopup } from "../stateManagement/actions/popupActions";

export async function commonPost(url:string,requestBody: any, authContext: AuthContextType): Promise<any> {
    const response = await ChannelkartNetworkPost(url, requestBody);
    return response.data;
}

export async function commonPut(url: string, requestBody: any, authContext: AuthContextType): Promise<any> {
    const response = await ChannelkartNetworkPut(url, requestBody);
    return response.data;
}


export async function commonGet(url:string, authContext: AuthContextType): Promise<any> {
    // const finalURL = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await ChannelkartNetworkGet(url)
    // const response = await axios.get(`${finalURL}`+url, {
    //     headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    // })
    return response.data;
}

export async function getReportInfoById(id:string): Promise<any> {
 //   const finalURL = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await ChannelkartNetworkGet("/v1/report/"+id);
    // const response = await axios.get(`${finalURL}` + "/v1/report/"+id, {
    //     headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    // })
    return response.data;
}

export async function getUserList(authContext: AuthContextType): Promise<any> {
   // const finalURL = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await ChannelkartNetworkGet("/v1/report/getuserlist");
    // const response = await axios.get(`${finalURL}` + "/v1/report/getuserlist", {
    //     headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    // })
    return response.data;
}

export async function convertPeriodToDate(period:string, year:string): Promise<any> {
       const response = await ChannelkartNetworkGet(`/v1/query/getDateRange?BusinessCalendar={"date":{ "type":"PERIOD","period":${period},"year":${year}}}`);
       return response.data;
   }

   export async function downloadReport(requestBody: downloadReportRequestBody) {
    
      const response = await ChannelkartNetworkPost("/tasks/types/report/execute", requestBody);
      
      return response;
  }

  export async function task(id: string) {
    const response = await ChannelkartNetworkGet("/tasks/" + id);
    return response;
}



export async function getMetadataForReport(){
    const response = await ChannelkartNetworkGet("/metadata");
    return response;
}

export async function getRoles(authContext: AuthContextType): Promise<any> {
    const response = await ChannelkartNetworkGet("/v1/divisions");
    return response.data;
}


export async function getFilters(authContext: AuthContextType): Promise<any> {
    //const response = await axios.get(`http://${authContext.user.lob}.localhost:8887/SPA/config/filters.json`, {
    //    headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    //})
    return jsonData;
}

export async function getClientConfig(authContext: AuthContextType,role:string): Promise<any> {
    const finalURL = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await axios.get(`${finalURL}` + `/metadata/uiconfig?name=${role}`, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
    return response.data;
}
export type ReportInfoRequestBody = {
    sourceLob: string,
    sourceEnvironment: string
    newReportName?:string
}
export type CloneReportInfoRequestBody = {
    sourceLob?: string,
    sourceEnvironment?: string,
    idList?:any[],
    newReportName?:string,
    newQueryName?:string
}

export async  function commonPostReportInfo(urlString:string,reportInfoRequestBody: CloneReportInfoRequestBody | ReportInfoRequestBody, authContext: AuthContextType) {
    const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
    const finalURL=  networkService.getFinalUrl(urlString);
    return  axios.post(finalURL , reportInfoRequestBody, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
}
export async function downloadReportOfID(id: string,batchDownload?: boolean){
    await getReport(id,batchDownload);
  }

export function getReportFilterAttribute(globalFilters: genericFilterType){
    const filter: filterType = {
        filters: []
    }
    const filterArray = [];
      for(let key in globalFilters){
        if(key==="banner"){
          const bannerTemplate = bannerTemplates.find((option: BannerTemplate) => {
            return option.label === globalFilters[key];
          })?.id;
          filterArray.push({
            key: "banner_type",
            value: bannerTemplate ?? ""
          })
        }else if(key==="district" || key==="branch" || key==="loginId" || key==="key2" || key==="loginID" || key==="status" || key==="entity" || key==="groupId" || key==="wdUser"){
          continue;
        }else if(globalFilters[key]){
          setReportFilterAttributes(filterArray,key,globalFilters[key]);
        }
      }
      const locationParam = getLocationParam(globalFilters);
      if(locationParam){
        setReportFilterAttributes(filterArray,"location",locationParam);
      }
      if(globalFilters["loginId"]){
        setReportFilterAttributes(filterArray,"user",globalFilters["loginId"]);
      }
      if(globalFilters["key2"]){
        setReportFilterAttributes(filterArray,"typeOfProgram",globalFilters["key2"]);
      }
      if(globalFilters["loginID"]){
        setReportFilterAttributes(filterArray,"distributor",globalFilters["loginID"]);
      }
      if(globalFilters["status"]){
        setReportFilterAttributes(filterArray,"statusFilter",globalFilters["status"]);
      }
      if(globalFilters["entity"]){
        setReportFilterAttributes(filterArray,"entityFilter",globalFilters["entity"]);
      }
      if(globalFilters["groupId"]){
        setReportFilterAttributes(filterArray,"groupidFilter",globalFilters["groupId"]);
      }
      if (globalFilters["wdUser"]) {
        if (Array.isArray(globalFilters["wdUser"])) {
          filterArray.push({
            key: "wdUser",
            value: globalFilters["wdUser"].join(","),
          });
        } else {
          filterArray.push({
            key: "wdUser",
            value: globalFilters["wdUser"],
          });
        }
      }
      filter.filters = filterArray;
      return filter;
}
export function setReportFilterAttributes(filterArray: filterObj[],key: string,values: string[] | string){
  if(Array.isArray(values)){
    for(let value of values){
      filterArray.push({
        key,
        value
      })
    }
  }else{
    filterArray.push({ 
      key, 
      value: values
    })
  }
}

export async function getSyncStatus(id: string) {
  const baseUrl = EnvironmentRegistry.getPromoServiceUrl();
  const lob = getLob();
  const token = getAccessToken();

  const url = `${baseUrl}/api/v1/promos/integration/syncstatus/${id}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'lob': lob,
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch sync status: ${response.status}`);
    }

    const json = await response.json();
    return {
      status: response.status,
      data: json
    };
    
  } catch (error) {
    console.error('Error fetching sync status:', error);
    return {
      status: 500,
      data: null
    };
  }
}

export async function getReport(id: string,batchDownload?: boolean){
  
  let baseUrl = EnvironmentRegistry.getServerUrl();
  
  const url =  baseUrl + "/v1/reports/" + id + (batchDownload ? "/batch" : "");
  await fetchAndDownloadReport(url);
}

export async function fetchAndDownloadReport(url: string){
  const token = getAccessToken();
  fetch(url,{
    headers: {
      'Authorization': `Bearer ${token}`, // Or any other scheme if different,
      'lob': getLob()
    }
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    // Extract filename from Content-Disposition header if available
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'download';
    if (contentDisposition && contentDisposition.includes('filename=')) {
      fileName = contentDisposition.split('filename=')[1].split(';')[0].trim();
    } else {
      const urlParts = url.split('/');
      fileName = urlParts[urlParts.length - 1];
    }

    // Return both the filename and the response blob
    return response.blob().then(blob => ({ blob, fileName }));
  })
  .then(({ blob, fileName }) => {
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = fileName; // Use the filename derived from the Content-Disposition header or the URL
    document.body.appendChild(anchor); // Required for Firefox
    anchor.click();
    document.body.removeChild(anchor); // Cleanup
    URL.revokeObjectURL(blobUrl);
  })
  .catch(error => {
    
    openPopup("Error","Something went wrong while downloading the file");
    console.error('Error downloading file:', error);
  });
}

export function getNameFromEmail(onlyFirstName: boolean) : string {
  let email = localStorage.getItem("user_email");
  if(email == null) return "";
  const localPart = email.split('@')[0];
  const parts = localPart.split('.');
  const capitalizedParts = parts.map(
    part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
  );
  const fullName = capitalizedParts.join(' ');
  if(onlyFirstName && fullName.length <= 11){
    return fullName;
  }
  return onlyFirstName ? capitalizedParts[0] : fullName;
}
